import React, { useLayoutEffect, useState } from 'react'

import moment from 'moment'

import { history } from '../../appRedux/store'
import IcoCalendar from '../../assets/images/ico_calendario.png'
import IcoLocal from '../../assets/images/ico_local.png'
import IcoAssign from '../../assets/images/ico_responsavel.png'
import './notificationItem.css'

moment.updateLocale(moment.locale('pt-br'), { invalidDate: '-' })

const NotificationItem = ({ notification, onClick }) => {
  const [icon, setIcon] = useState(IcoAssign)
  const { messageTitle, created_at, notifyOn } = notification
  const isRead = notification.readOn && notification.readOn.includes('desktop')

  useLayoutEffect(() => {
    if (notifyOn.subtype === 'lateVisit') {
      setIcon(IcoLocal)
    }

    if (notifyOn.subtype === 'todayVisit') {
      setIcon(IcoCalendar)
    }
  }, [])

  function handleActionNotification({ actionTypeId, actionId }) {
    history.push(`/actions/${actionTypeId}/${actionId}`)
  }

  function handleWalletEditionNotification() {
    history.push(`/customerWallet/list`)
  }

  function handleClick() {
    if (notification.notifyOn.type === 'action') {
      handleActionNotification(notification.notifyOn)
    }

    if (notification.notifyOn.type === 'walletEdition') {
      handleWalletEditionNotification()
    }

    onClick(notification)
  }

  return (
    <li className={`notification-item ${isRead ? 'read' : ''}`} onClick={handleClick}>
      <img className="icon" alt={icon} src={icon} />

      <div className="gx-media-body gx-align-self-center">
        <span className="gx-meta-date">
          <small>{moment(created_at).format('DD/MM/YYYY - HH:mm')}</small>
        </span>
        <p className="gx-fs-sm gx-mb-0">{messageTitle}</p>
        <small className="gx-meta-link">Clique aqui para visualizar</small>
      </div>
    </li>
  )
}

export default NotificationItem
